import { render, staticRenderFns } from "./RemProvider.vue?vue&type=template&id=3fcb7538&"
import script from "./RemProvider.vue?vue&type=script&lang=js&"
export * from "./RemProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports